import { FC, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { RouteUrl } from 'app/routes'

/**
 * FormEditRoute - Redirects to review page
 *
 * This route is kept for backward compatibility but editing is now done
 * via modal in the review page. Any direct navigation to this route will
 * redirect to the review page.
 */
export const FormEditRoute: FC = () => {
    const navigate = useNavigate()
    const { formId } = useParams<{ formId: string }>()

    useEffect(() => {
        if (formId) {
            // Redirect to review page - editing is done via modal there
            navigate(RouteUrl.FormReviewById.path.replace(':formId', formId), {
                replace: true,
            })
        }
    }, [formId, navigate])

    return null
}
